import { appointmentStatusEnumList } from '../../../components/AgGrid/enumLists'

const appointmentStatusLabelValueGetter = (props) => {
  const { value } = props
  return appointmentStatusEnumList(value)
}

export default appointmentStatusLabelValueGetter
